import styled from 'styled-components'

import { Grid } from '@material-ui/core'

export const Container = styled(Grid)`
  gap: 24px;
`
